export default "assets/logo02_old-6d3950ed.png";